module.exports = __webpack_public_path__ + "static/media/picVideo.48d93cc3.png";